export const mapWorker = new Worker(
  new URL("portal/workers/mapWorker.ts", import.meta.url),
  { type: "module" }
);

mapWorker.addEventListener("error", (e: any) => {
  console.error("An Error occurred in MapWorker:", e);
});

export const shapefileImportWorker = new Worker(
  new URL("portal/workers/shapefileImportWorker.ts", import.meta.url),
  { type: "module" }
);
shapefileImportWorker.addEventListener("error", (e: any) => {
  console.error("An Error occurred in ShapefileImportWorker:", e);
});
